import ContactBusinessHours from '../components/contact/ContactBusinessHours'
import ContactInfoSection from '../components/contact/ContactInfoSection'
import ContactMapSection from '../components/contact/ContactMapSection'
import ContactPageCta from '../components/contact/ContactPageCta'
import ContactPageHero from '../components/contact/ContactPageHero'
import ContactWhySection from '../components/contact/ContactWhySection'
import ContactFormsTabsSection from '../components/contact/ContactFormsTabsSection'
import SEO from '../components/common/SEO'

function Contact() {
  return (
    <>
      <SEO
        title="Contact"
        description="Contact Torbit Metals Private Limited for quote requests, general inquiries, sourcing, procurement and industrial supply requirements."
      />
      <ContactPageHero />
      <ContactInfoSection />
      <ContactFormsTabsSection />
      <ContactWhySection />
      <ContactMapSection />
      <ContactBusinessHours />
      <ContactPageCta />
    </>
  )
}

export default Contact
